export default __webpack_public_path__ + "static/media/jungle.beab9d41.svg";